import { useContext, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ChatResponseType } from '@trinity/chat';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { useActiveBrandIdentifierNullSafe } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier';
import { ActiveChatSessionContext, ChatHintsLoadingContext, ChatInitialResponseContext } from './context';
import { useActiveApplicationIdentifierNullSafe } from '@trinity/chat-components/containers/UserApplications/useActiveApplicationIdentifier';

type Props = {
  children: React.ReactNode;
};

export const ChatHintsContainer = (props: Props) => {
  const chat = useContext(ActiveChatSessionContext);
  const brandIdentifier = useActiveBrandIdentifierNullSafe();
  const applicationIdentifier = useActiveApplicationIdentifierNullSafe();
  const client = useChatApiClient();

  const query = useQuery({
    queryKey: ['chat-hints', chat.identifier, chat.context, brandIdentifier, applicationIdentifier],
    queryFn: () => {
      return client.chat.getChatInitialMessage({
        context: chat.context,
        brandIdentifier,
        applicationIdentifier,
      });
    },
    refetchOnMount: 'always',
    initialData: {
      type: ChatResponseType.InitialGreeting,
      value: '',
      data: {
        hints: [],
      },
    },
  });

  const loading = useMemo(() => {
    return query.isFetching;
  }, [query.isFetching]);

  return (
    <ChatInitialResponseContext.Provider value={query.data}>
      <ChatHintsLoadingContext.Provider value={loading}>{props.children}</ChatHintsLoadingContext.Provider>
    </ChatInitialResponseContext.Provider>
  );
};
